<template>
  <router-view></router-view>
</template>

<style lang="scss">
// 3rd party plugins css
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~@fortawesome/fontawesome-free/css/all.min.css";
@import "assets/plugins/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";

// Main demo style scss
@import "assets/sass/style.vue";

// Check documentation for RTL css
/*@import "assets/css/style.vue.rtl";*/

// Demo skins (demo1 only)
@import "assets/sass/global/integration/frameworks/vue/skins";
</style>

<script>
import { mapGetters } from "vuex";
// import { CLEAR_AUTH } from "@/store/auth.module";
import { LOAD_APP_CONFIG } from "@/store/config.module";

export default {
  name: "AffiliateApp",
  computed: {
    ...mapGetters(["isAuthenticated", "getSection", "appConfigLoaded"])
  },
  beforeMount() {
    if (!this.appConfigLoaded) {
      this.$store
        .dispatch(LOAD_APP_CONFIG)
        .then(() => {
          this.configLoaded = true;
        })
        .catch(() => {
          this.configLoaded = false;
        });
    }
  },
  mounted() {
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/common/config/layout.config.json)
     */
    // this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
    // const route_prefix =
    //   this.getSection === "default" ? "" : this.getSection + "-";
    // this.prefix = route_prefix;
    // if (!this.isAuthenticated) {
    //   // console.log(this.$route);
    //   console.log("Logout 2");
    //   this.$store.dispatch(CLEAR_AUTH, this.getSection);
    //   this.$router.push({ name: `${route_prefix}login` });
    //   // this.goToLogin();
    // }
  },
  methods: {}
};
</script>
